import React from 'react';

type Props = {
  children: React.ReactNode;
  reference: React.RefObject<HTMLDivElement | null>;
  className?: string;
};

function StyledModal({ children, reference, className = '' }: Props) {
  return (
    <div
      ref={reference}
      className={`bg-bg-elevated w-full max-w-lg rounded-xl shadow-2xl ${className}`}
    >
      {children}
    </div>
  );
}

export default StyledModal;
